import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { CreateJobRequest, IAllJobsResponse, IJob, IJobStatsResponse } from "../models/Job";
import { IExportOffer } from "../models/ExportOffer";
// import { ISetting, ISettingsResponse } from "../models/Setting";

export default function useExportOffers() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const create = useMutation(
    (exportOffer: any) => post(`/exportOffer`, exportOffer),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["pagedTable"]);
      },
    }
  );

  const update = useMutation(
    (exportOffer: IExportOffer) => put(`/exportOffer/${exportOffer.id}`, exportOffer),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["pagedTable"]);
      },
    }
  );

  const accept = useMutation(
    (exportOfferId: any) => post(`/exportOffer/accept/${exportOfferId}`, {}),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["pagedTable"]);
      },
    }
  );

  const remove = useMutation(
    (exportOfferId: any) => del(`/exportOffer/${exportOfferId}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["pagedTable"]);
      },
    }
  );

  return {
    create,
    update,
    accept,
    remove,
  };
}
